/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import MediaTypeIcon from 'icons/MediaTypeIcon';

const messages = defineMessages({
  title: {id: 'navigation.instructional-materials.media-types'},
});

const MediaTypesItem = () => (
  <RouteLinkItem
    iconBefore={MediaTypeIcon}
    route="midas/instructional-materials/media-types"
    title={messages.title}
  />
);

export default MediaTypesItem;
